import { render } from "./PHOTOSHOP_DOWNLOAD.vue?vue&type=template&id=6a85f008"
import script from "./PHOTOSHOP_DOWNLOAD.vue?vue&type=script&lang=js"
export * from "./PHOTOSHOP_DOWNLOAD.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__